export default {
  type: "dingTalk",
  isEnv() {
    return /\DingTalk/.test(navigator.userAgent);
  },
  init(opt = {}) {
    try {
      return new Promise((resolve, reject) => {
        let { sdkUrl } = opt;
        if (!sdkUrl) {
          throw "请传入dingTalk.sdkUrl";
        }
        dsf.http
          .importFiles(opt.sdkUrl)
          .then(([{ state }]) => {
            // 加载sdk
            if (!state) {
              console.error("钉钉sdk加载出错");
              reject(`${sdkUrl}文件出错`);
            }
            dd.ready(() => {
              //钉钉禁止ios页面在上下边界滑动时页面弹动效果
              dd?.ui?.webViewBounce?.disable?.();
              resolve();
            });
          })
          .catch((err) => {
            reject(err);
          });
      });
    } catch (error) {
      return Promise.reject(error);
    }
  },
  methods: {
    /**
     * 选择图片
     * @returns {*}
     */
    chooseImage() {
      return dsf.file.load(".png,.jpg,.gif", true);
    },
    /**
     * 预览图片
     * @param options.current 当前显示图片的http链接
     * @param options.urls 需要预览的图片http链接列表
     * @returns {*}
     */
    previewImage(options = {}) {
      return new Promise((resolve, reject) => {
        dd.previewImage({
          urls: options.urls || [],
          current: options.current || 1,
          success: () => {
            resolve();
          },
          fail: () => {
            reject();
          },
        });
      });
    },
    /**
     * 扫码
     * @param options.scanType 可以指定扫二维码还是一维码，默认二者都有
     * @returns {*}
     */
    scan(opt = {}) {
      return new Promise((resolve, reject) => {
        try {
          let type = "all";
          let inputType = opt.scanType || opt.type;
          if (inputType) {
            type = { qrCode: "qr", barCode: "bar" }[inputType];
          }
          dd?.biz?.util?.scan({
            type: type, // type 为 all、qrCode、barCode，默认是all。
            onSuccess: (data) => {
              resolve(data.text);
            },
            onFail: (err) => {
              reject(err);
            },
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    /**
     * 获取地理位置接口
     * @param options.type 默认为wgs84的gps坐标
     */
    getLocation: getGeolocation,
    /**
     * 使用应用内置地图查看位置
     * @param options.latitude 纬度，浮点数，范围为90 ~ -90
     * @param options.longitude 经度，浮点数，范围为180 ~ -180
     * @param options.title 位置名
     * @param options.address 地址详情说明
     */
    openLocation(opt = {}) {
      return new Promise((resolve, reject) => {
        dd.openLocation({
          title: opt.name,
          address: opt.address,
          latitude: opt.latitude,
          longitude: opt.longitude,
          success: () => {
            resolve();
          },
          fail: () => {
            reject();
          },
        });
      });
    },
    /**
     * 拨打电话
     * @param options
     * @param options.phoneNumber {string} 手机号码
     */
    callPhone(opt = {}) {
      return new Promise((resolve, reject) => {
        try {
          let _opt = this._getFuncOpts(
            {
              phoneNumber: "", // 手机号
              code: "+86", // 国家代号，中国是+86。
              showDingCall: false, // 是否显示钉钉电话。
            },
            opt
          );
          if (!_opt.phoneNumber) throw "请传入phoneNumber电话号码";
          dd.biz.telephone.showCallMenu({
            phoneNumber: _opt.phoneNumber, // 期望拨打的电话号码
            code: _opt.phoneNumber.code, // 国家代号，中国是+86
            showDingCall: _opt.phoneNumber.showDingCall, // 是否显示钉钉电话
            onSuccess: function () {
              resolve();
            },
            onFail: function () {
              reject();
            },
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    // 获取授权码
    getAuthCode(opt = {}) {
      return new Promise((resolve, reject) => {
        try {
          let _opt = this._getFuncOpts(
            {
              corpId: "ding58a6e4aef9bb5cfa35c2f4657eb6378f",
            },
            opt
          );
          if (!_opt.corpId) throw "请传入corpId";
          dd.runtime.permission.requestAuthCode({
            corpId: _opt.corpId,
            onSuccess: (res) => {
              if (res.code) {
                resolve(res.code);
              } else {
                throw res;
              }
            },
            onFail: (err) => {
              reject(err);
            },
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    makePhoneCall(opt) {
      return this.callPhone(opt);
    },
    // 设备唯一标识
    getDeviceCode() {
      return new Promise((resolve, reject) => {
        try {
          dd.device.base.getUUID({
            onSuccess: (data) => {
              resolve(data.uuid);
            },
            onFail: (err) => {
              reject(err);
            },
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    // 新开页面
    open(opt = {}) {
      return new Promise((resolve, reject) => {
        let _opt = this._getFuncOpts(
          {
            url: "", // 网址
          },
          opt
        );
        if (!_opt.url) throw "请传入url";
        try {
          dd.biz.util.openLink({
            url: _opt.url, //要打开链接的地址
            onSuccess: function (result) {
              /**/
              resolve();
            },
            onFail: function (err) {
              reject(err);
            },
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    // 设置 浏览器 title
    navigationSetTitle(opt = {}) {
      return new Promise((resolve, reject) => {
        try {
          let _opt = this._getFuncOpts(
            {
              title: "", // 网址
            },
            opt
          );
          dd.biz.navigation.setTitle({
            title: _opt.title, //控制标题文本，空字符串表示显示默认文本
            onSuccess: function (result) {
              resolve(result);
            },
            onFail: function (err) {
              reject(err);
            },
          });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};

// 获取定位
function getGeolocation(opt = {}) {
  return new Promise((resolve, reject) => {
    try {
      let type = 0;
      if (opt.type == "gcj02") {
        type = 1;
      }
      return dd.getLocation({
        type: type,
        withReGeocode: true,
        success: (data) => {
          let res = {
            type: ["wgs84", "gcj02"][type],
            longitude: data.longitude,
            latitude: data.latitude,
            lng: data.longitude,
            lat: data.latitude,
          };
          res["_" + this.$type] = data;
          resolve();
        },
        fail: (error) => {
          return reject(error);
        },
      });
    } catch (error) {
      return reject(error);
    }
  });
}
